import type {Progress} from './progressSchema';

export interface TopicScoreAggregate {
  score: number;
  difficulty: number;
}

export type TopicScoreMap = Record<string, TopicScoreAggregate>;

/**
 * Build a map of topic scores from a progress object.
 * For each topic, keeps the score at the highest difficulty encountered.
 */
export function buildProgressScoreMap(progress: Progress): TopicScoreMap {
  return progress.scores.reduce<TopicScoreMap>((acc, s) => {
    const existing = acc[s.topic];
    if (!existing || s.difficulty > existing.difficulty) {
      acc[s.topic] = {
        score: s.score ?? 0,
        difficulty: s.difficulty ?? 0,
      };
    }
    return acc;
  }, {});
}
